import { Component, ElementRef, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesProvider } from '@providers/utilities-provider';

// safe area code

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  @ViewChild('mainAppContainer') mainAppContainer: ElementRef;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private utilitiesProvider: UtilitiesProvider
  ) {
    this.initializeApp();
    this.utilitiesProvider.initiateSentry();
  }

  initializeApp(): void {
    this.platform.ready().then(() => {
      this.getTranslation();
    });
  }

  private getTranslation() {
    this.translate.setDefaultLang('en');

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('en');
    }
  }
}
